// B1 - Final Sınavı
// Kapsamlı final sınavı - Tüm B1 konuları

export const B1_FINAL = {
  'B1-FINAL': {
    id: 'B1-FINAL',
    title: 'B1 Final Sınavı',
    type: 'exam',
    exercises: [
      // UNIT 1: Future - Will
      {
        type: 'multipleChoice',
        question: 'The flight _____ at 3 PM tomorrow.',
        options: ['will depart', 'departs', 'is departing', 'departed'],
        correct: 'will depart',
        explanation: 'Future with will: will + fiil'
      },
      {
        type: 'multipleChoice',
        question: 'Don\'t worry. I _____ help you with your bag.',
        options: ['will', 'am going to', 'going to', 'would'],
        correct: 'will',
        explanation: 'Spontaneous offer: will'
      },
      {
        type: 'fillInBlank',
        sentence: 'I promise I _____ (not/be) late.',
        answer: 'won\'t be',
        hint: 'Promise: will + not = won\'t'
      },
      
      // UNIT 2: Future - Going to
      {
        type: 'multipleChoice',
        question: 'I _____ apply for the cabin crew position next month.',
        options: ['am going to', 'will to', 'going to', 'am go to'],
        correct: 'am going to',
        explanation: 'Plan: am/is/are going to + fiil'
      },
      {
        type: 'multipleChoice',
        question: 'Look at those clouds! It _____ rain.',
        options: ['is going to', 'will', 'is', 'going to'],
        correct: 'is going to',
        explanation: 'Evidence-based prediction: going to'
      },
      {
        type: 'fillInBlank',
        sentence: 'She _____ (going to / start) training next week.',
        answer: 'is going to start',
        hint: 'She is going to + fiil'
      },
      
      // UNIT 3: Comparatives & Superlatives
      {
        type: 'multipleChoice',
        question: 'This aircraft is _____ than that one.',
        options: ['bigger', 'more big', 'biger', 'biggest'],
        correct: 'bigger',
        explanation: 'Comparative: -er (big → bigger)'
      },
      {
        type: 'multipleChoice',
        question: 'Business class is _____ than economy.',
        options: ['more comfortable', 'comfortabler', 'most comfortable', 'comfortable'],
        correct: 'more comfortable',
        explanation: 'Long adjective comparative: more + adjective'
      },
      {
        type: 'multipleChoice',
        question: 'This is _____ airline in the world.',
        options: ['the best', 'the better', 'the goodest', 'better'],
        correct: 'the best',
        explanation: 'Superlative: the best (good → better → best)'
      },
      
      // UNIT 4: First Conditional
      {
        type: 'multipleChoice',
        question: 'If the weather _____ bad, we will delay the flight.',
        options: ['is', 'will be', 'was', 'would be'],
        correct: 'is',
        explanation: 'First conditional: If + Present Simple'
      },
      {
        type: 'multipleChoice',
        question: '_____ you hurry, you will miss the flight.',
        options: ['Unless', 'If', 'When', 'Although'],
        correct: 'Unless',
        explanation: 'Unless = If not'
      },
      {
        type: 'fillInBlank',
        sentence: 'If passengers cooperate, we _____ (have) a smooth flight.',
        answer: 'will have',
        hint: 'Main clause: will + fiil'
      },
      
      // UNIT 5: Modal Verbs
      {
        type: 'multipleChoice',
        question: 'Passengers _____ fasten their seatbelts during takeoff.',
        options: ['must', 'should', 'might', 'could'],
        correct: 'must',
        explanation: 'Strong obligation (safety rule): must'
      },
      {
        type: 'multipleChoice',
        question: 'You _____ smoke on the aircraft.',
        options: ['mustn\'t', 'don\'t have to', 'shouldn\'t', 'needn\'t'],
        correct: 'mustn\'t',
        explanation: 'Prohibition: mustn\'t'
      },
      {
        type: 'multipleChoice',
        question: 'You _____ bring food. We serve meals on board.',
        options: ['don\'t have to', 'mustn\'t', 'must', 'should'],
        correct: 'don\'t have to',
        explanation: 'No obligation: don\'t have to'
      },
      {
        type: 'multipleChoice',
        question: 'You _____ research the company before the interview.',
        options: ['should', 'must', 'have', 'mustn\'t'],
        correct: 'should',
        explanation: 'Advice: should'
      },
      
      // UNIT 6: Present Perfect Continuous & Time Clauses
      {
        type: 'multipleChoice',
        question: 'I _____ for this airline for 5 years.',
        options: ['have been working', 'am working', 'work', 'worked'],
        correct: 'have been working',
        explanation: 'Present Perfect Continuous: have been + -ing'
      },
      {
        type: 'multipleChoice',
        question: 'When we _____, please remain seated.',
        options: ['land', 'will land', 'landed', 'are landing'],
        correct: 'land',
        explanation: 'Time clause: Present Simple (no will)'
      },
      {
        type: 'fillInBlank',
        sentence: 'She has been learning English _____ 2020.',
        answer: 'since',
        hint: 'Specific point in time = since'
      },
      
      // MIXED EXERCISES
      {
        type: 'matchPairs',
        instruction: 'Modal fiilleri eşleştirin',
        pairs: [
          { left: 'must', right: 'zorunluluk' },
          { left: 'mustn\'t', right: 'yasak' },
          { left: 'should', right: 'tavsiye' },
          { left: 'don\'t have to', right: 'zorunlu değil' }
        ]
      },
      {
        type: 'matchPairs',
        instruction: 'For vs Since',
        pairs: [
          { left: '3 years', right: 'for' },
          { left: '2020', right: 'since' },
          { left: '6 months', right: 'for' },
          { left: 'January', right: 'since' }
        ]
      },
      {
        type: 'matchPairs',
        instruction: 'Comparatives eşleştirin',
        pairs: [
          { left: 'good', right: 'better' },
          { left: 'bad', right: 'worse' },
          { left: 'big', right: 'bigger' },
          { left: 'comfortable', right: 'more comfortable' }
        ]
      },
      
      // INTERVIEW FOCUS
      {
        type: 'multipleChoice',
        question: 'Interview: "Where do you see yourself in 5 years?" - I _____ be a senior cabin crew member.',
        options: ['will', 'am going to', 'would', 'could'],
        correct: 'will',
        explanation: 'Future plan/prediction: will'
      },
      {
        type: 'multipleChoice',
        question: 'Interview: "What will you do if a passenger is rude?" - If a passenger is rude, I _____ remain calm and professional.',
        options: ['will', 'would', 'am going to', 'must'],
        correct: 'will',
        explanation: 'First conditional: will'
      }
    ]
  }
};

export default B1_FINAL;
